/** @format */

import { dateConstants } from './actions';
import { reducerDebug } from '../../core/debug';

const initialState = {
    year: null,
    month: null,
    predefinedMonth: null,
};

export type DateReducersType = {
    type?: string;
    year?: number | null;
    month?: number | null;
    predefinedMonth?: number | null;
};

export function dateReducers(state = initialState, action: DateReducersType): object {
    reducerDebug('Date reducer: ' + action.type);
    switch (action.type) {
        case dateConstants.DATE_EDIT:
            return {
                ...state,
                ...action,
            };
        default:
            return {
                ...state,
            };
    }
}
